import React from 'react';
import styled from 'styled-components';
import { Col, Input, Radio, Row, Select } from 'tdesign-react';
import { SearchIcon } from 'tdesign-icons-react';
import { connect } from 'react-redux';
import ShadowCard from '@/components/ShadowCard';
import { toTsOptions } from '@/utils/common';
import Form from '@/components/Form';
import Summary from './Summary';

const { FormItem } = Form;

function FilterForm({
  deployEnvs,
  kafkaVersions,
  clusterUsage,
  deployVersions,
  filterOptions,
  orderOptions,
}) {
  return (
    <Root>
      <Summary />

      <FormItem name='clusterName'>
        <Input placeholder='请输入集群名' suffixIcon={<SearchIcon />} />
      </FormItem>
      <FormItem className='hack_radio_button_theme' label='部署方式' name='deployEnv'>
        <Radio.Group variant='primary-filled'>
          <Radio.Button value=''>全部</Radio.Button>
          {deployEnvs.map((item) => (
            <Radio.Button key={item.value} value={item.value}>
              {item.label}
            </Radio.Button>
          ))}
        </Radio.Group>
      </FormItem>
      <FormItem className='hack_radio_button_theme' label='版本分布' name='version'>
        <Radio.Group variant='primary-filled'>
          <Radio.Button value=''>全部</Radio.Button>
          {kafkaVersions.map((item) => (
            <Radio.Button key={item.value} value={item.value}>
              {item.label}
            </Radio.Button>
          ))}
        </Radio.Group>
      </FormItem>

      <FormItem label='分配方式' name='clusterUsage'>
        <Select placeholder='选择集群分配方式' clearable options={toTsOptions(clusterUsage)} />
      </FormItem>
      <FormItem label='部署版本' name='deployVersion'>
        <Select placeholder='选择部署版本' clearable options={toTsOptions(deployVersions)} />
      </FormItem>
      <Row align='bottom' justify='space-between'>
        <Col span={6}>
          <FormItem label='排序' name='sortKey'>
            <Select placeholder='请选择' clearable options={toTsOptions(filterOptions)} />
          </FormItem>
        </Col>
        <Col span={5}>
          <FormItem className='hack_radio_button_theme' name='sortType'>
            <Radio.Group variant='primary-filled'>
              {orderOptions.map((item) => (
                <Radio.Button key={item.value} value={item.value}>
                  {item.label}
                </Radio.Button>
              ))}
            </Radio.Group>
          </FormItem>
        </Col>
      </Row>
    </Root>
  );
}

export default connect((state) => ({
  deployEnvs: state.dict.deployEnvs,
  kafkaVersions: state.dict.kafkaVersions,
  clusterUsage: state.dict.clusterUsage,
  deployVersions: state.dict.deployVersions,
  filterOptions: state.kopCluster.filterOptions,
  orderOptions: state.kopCluster.orderOptions,
}))(FilterForm);

const Root = styled(ShadowCard)`
  width: 300px;
  flex-shrink: 0;
  padding-bottom: 30px;
  margin-right: 16px;
`;
